var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ECardType } from "../enums";
import { DoubleVideoCard, LargeImageCard, LargeTextCard, SingleMatchCard, SinglePlayerCard, SingleShopCard, SmallImageCard, SmallTextCard } from "./commonCards";
export var CardRouter = function (props) {
    switch (props.data.type) {
        case ECardType.SINGLE_IMAGE:
            return _jsx(SmallImageCard, __assign({}, props.data));
        case ECardType.SINGLE_TEXT:
            return _jsx(SmallTextCard, __assign({}, props.data));
        case ECardType.DOUBLE_IMAGE:
            return _jsx(LargeImageCard, __assign({}, props.data));
        case ECardType.DOUBLE_TEXT:
            return _jsx(LargeTextCard, __assign({}, props.data));
        case ECardType.SINGLE_VIDEO:
            break;
        case ECardType.DOUBLE_VIDEO:
            return _jsx(DoubleVideoCard, __assign({}, props.data));
        case ECardType.SINGLE_SHOP_ITEM:
            return _jsx(SingleShopCard, __assign({}, props.data));
        case ECardType.PLAYER_SINGLE:
            return _jsx(SinglePlayerCard, __assign({}, props.data));
        case ECardType.PLAYER_DOUBLE:
            break;
        case ECardType.SINGLE_MATCH:
            return _jsx(SingleMatchCard, __assign({}, props.data));
        case ECardType.WIDE_PAST_MATCH:
            break;
        case ECardType.WIDE_UPCOMING_MATCH:
            break;
    }
    throw ("Card type not supported");
};
